import { useBrand } from "../../../../../../common/providers/brand/brand-context";
import { getBookshelfHost } from "../../../../../../common/utils/bookshelfLink";

interface LibraryConfig {
  isLibraryEnabled: boolean;
  libraryHref: string;
  isLibraryExternal: boolean;
}

export default function useLibraryConfig(): LibraryConfig {
  const brand = useBrand();
  const isLibraryEnabled = brand.getProp<boolean>("Library.enabled");
  const customURL = brand.getProp<string>("Library.redirectURL");
  const libraryHref = customURL || getBookshelfHost() + "/";
  const isLibraryExternal = !!customURL;

  return { isLibraryEnabled, libraryHref, isLibraryExternal };
}
